import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { setDayFilterSliderSettings } from "../../../../Shared/utils/sliderSettings";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { Typography, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { DEFAULT_DAY_COUNT } from "../../../OrderFlowProvider/OrderFlowTypes";
const handleSelectedDayChange = (selectedDay, dispatch) => (event) => {
    const day = moment(event.currentTarget.value);
    if (moment(selectedDay).isSame(day)) {
        return;
    }
    dispatch({ type: ActionTypes.SET_SELECTED_DAY, payload: day });
};
const CreateDayFormattedLabel = (day, dayFormat) => {
    if (dayFormat && dayFormat.length) {
        return (_jsx(Stack, { children: dayFormat.map((formatString) => (_jsx(Typography, { children: moment(day).format(formatString) }, formatString))) }));
    }
    else {
        return _jsx(Typography, { children: moment(day).format("MMM D") });
    }
};
export const useDayFilter = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { store, dispatch } = useOrderFlow();
    const theme = useTheme();
    const onlyDaysWithDefaultMeals = (_b = (_a = store === null || store === void 0 ? void 0 : store.model) === null || _a === void 0 ? void 0 : _a.dayFilterConfig) === null || _b === void 0 ? void 0 : _b.OnlyDaysWithDefaultMeals;
    const mealSelectionStatus = (_c = store.model.MealSelectionStatus) === null || _c === void 0 ? void 0 : _c.completed;
    const dayCount = (_e = (_d = store.model.dayFilterConfig) === null || _d === void 0 ? void 0 : _d.DayCount) !== null && _e !== void 0 ? _e : DEFAULT_DAY_COUNT;
    const dayFilterDays = (_f = store.model.dayFilterDays) === null || _f === void 0 ? void 0 : _f.slice(0, dayCount);
    const sliderSettings = setDayFilterSliderSettings(theme, (_h = (_g = store === null || store === void 0 ? void 0 : store.model) === null || _g === void 0 ? void 0 : _g.dayFilterConfig) === null || _h === void 0 ? void 0 : _h.FilterLG, (_k = (_j = store === null || store === void 0 ? void 0 : store.model) === null || _j === void 0 ? void 0 : _j.dayFilterConfig) === null || _k === void 0 ? void 0 : _k.FilterMD, (_m = (_l = store === null || store === void 0 ? void 0 : store.model) === null || _l === void 0 ? void 0 : _l.dayFilterConfig) === null || _m === void 0 ? void 0 : _m.FilterSM, (_p = (_o = store === null || store === void 0 ? void 0 : store.model) === null || _o === void 0 ? void 0 : _o.dayFilterConfig) === null || _p === void 0 ? void 0 : _p.FilterXS);
    const dayFilterFormat = (_r = (_q = store === null || store === void 0 ? void 0 : store.model) === null || _q === void 0 ? void 0 : _q.dayFilterConfig) === null || _r === void 0 ? void 0 : _r.DayFilterFormat;
    const selectedDay = store.cart.selectedDay;
    return {
        onlyDaysWithDefaultMeals,
        mealSelectionStatus,
        dayFilterDays,
        sliderSettings,
        dayFilterFormat,
        selectedDay,
        handleSelectedDayChange: handleSelectedDayChange(selectedDay, dispatch),
        CreateDayFormattedLabel,
    };
};
